import { IUser } from '../../../interfaces/User.interfaces';
import { customAxios } from '../../common/customAxios';

interface IPutUsersMeParams {
  reqBody: {
    email?: string;
    phoneNumber?: string;
    nickname?: string;
    pushNotiApproval?: boolean;
    smsNotiApproval?: boolean;
    marketingTermsAgreement?: boolean;
    advertisementTermsAgreement?: boolean;
    profileImage?: string;
  };
}

export const putUsersMe = ({ reqBody }: IPutUsersMeParams): Promise<IUser> => {
  return customAxios.put('/users/me', reqBody);
};
